export default "__VITE_ASSET__CMjV_hxs__"